<div mat-dialog-title class="flex-container">
    <button mat-button class="close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
    <h1>Assign / Deassign - {{assignedScheduler.schedulerName}}</h1>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="_assignForm">

      <div class="row">
        <div class="col-lg-12 d-flex">
          <div class="col-lg-6">
            <p>Select Client<span>*</span></p>
            <mat-form-field appearance="none" class="manage-select">
              <mat-select formControlName="clientId" (selectionChange)="getProjectsByClient($event)"
                placeholder="Select Client" required>
                <mat-option *ngFor="let client of clients" [value]="client.clientId">{{ client.clientName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <p>Select Project<span>*</span></p>
            <mat-form-field appearance="none" class="manage-select">
              <mat-select formControlName="projectIds" (selectionChange)="getSchedulersByProject($event)" placeholder="Select Project" multiple required>
                <mat-option *ngFor="let project of projects" [value]="project.projectId">{{ project.projectName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- div class="row">
        <div class="col-lg-12 d-flex">
          <div class="col-lg-6">
            <p>Select Batches<span>*</span></p>
            <mat-form-field appearance="none" class="manage-select">
              <mat-select formControlName="assignedBatches" (selectionChange)="getBatchesByProject($event)"
                placeholder="Select Batches" required multiple>
                <mat-option *ngFor="let batch of batches" [value]="batch">{{ batch }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-6">
          </div>
        </div>
      </div -->
      <div class="row">
        <div *ngIf="selectedProjects != null && selectedProjects.length > 0" class="col-lg-12">
          <p>Assigned Projects</p>
          <ul style="padding: 0px;">
            <li class="priorityli" *ngFor="let p of selectedProjects; let even = even; let odd = odd"
              [ngClass]="{ odd: odd, even: even }">{{p.projectName}}</li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div *ngIf="!isAssigned" class="col-lg-12 toparea">
          <button mat-raised-button mat-button (click)="assign()" [disabled]="!_assignForm.valid"
            class="btn btn-icon-text3 md-button-right">
            ASSIGN
          </button>
        </div>
        <div *ngIf="isAssigned" class="col-lg-12 toparea">
          <button mat-raised-button mat-button (click)="deassign()"
            class="btn btn-icon-text3 md-button-right">
            DEASSIGN
          </button>
        </div>
      </div>

  </form>
  </div>
